<div class="full-screen">
    <div class="content">
        <h2>{{ title }}</h2>
        <p>{{ message }}</p>
    </div>
</div>
